jQuery(function ($) {
    const $root = $('[data-carbuy-admin-flyout]');
    if (!$root.length) return;

    const $toggle = $root.find('[data-carbuy-admin-flyout-toggle]').first();
    const $panel = $root.find('#carbuy-admin-flyout-panel').first();
    if (!$toggle.length || !$panel.length) return;

    function isOpen() {
        return $root.hasClass('is-open');
    }

    function open() {
        $root.addClass('is-open');
        $panel.prop('hidden', false);
        $toggle.attr('aria-expanded', 'true');
    }

    function close() {
        $root.removeClass('is-open');
        $panel.prop('hidden', true);
        $toggle.attr('aria-expanded', 'false');
    }

    $toggle.on('click', function (e) {
        e.preventDefault();
        if (isOpen()) close();
        else open();
    });

    $(document).on('click', function (e) {
        if (!isOpen()) return;
        const $t = $(e.target);
        if ($t.closest('[data-carbuy-admin-flyout]').length) return;
        close();
    });

    $(document).on('keydown', function (e) {
        if (!isOpen()) return;
        if (e.key === 'Escape') {
            close();
        }
    });
});

